import React from 'react';

export function Input({
  label,
  error,
  helper,
  icon: Icon,
  className = '',
  ...props
}) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-text-primary">
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted">
            <Icon className="w-5 h-5" />
          </div>
        )}
        <input
          className={`
            input-field
            ${Icon ? 'pl-10' : ''}
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : ''}
          `}
          {...props}
        />
      </div>
      {helper && !error && (
        <p className="text-sm text-text-muted">{helper}</p>
      )}
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
}

export function Textarea({
  label,
  error,
  helper,
  rows = 4,
  className = '',
  ...props
}) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-text-primary">
          {label}
        </label>
      )}
      <textarea
        className={`
          textarea-field
          ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : ''}
        `}
        rows={rows}
        {...props}
      />
      {helper && !error && (
        <p className="text-sm text-text-muted">{helper}</p>
      )}
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
}

export function Select({
  label,
  options,
  error,
  helper,
  placeholder = 'Select an option',
  className = '',
  ...props
}) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-text-primary">
          {label}
        </label>
      )}
      <select
        className={`
          input-field cursor-pointer
          ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : ''}
        `}
        {...props}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((option) => (
          <option key={option.value || option} value={option.value || option}>
            {option.label || option}
          </option>
        ))}
      </select>
      {helper && !error && (
        <p className="text-sm text-text-muted">{helper}</p>
      )}
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
}
